import { render, staticRenderFns } from "./setting-zapierConnections.vue?vue&type=template&id=530b02c0&scoped=true&"
import script from "./setting-zapierConnections.vue?vue&type=script&lang=js&"
export * from "./setting-zapierConnections.vue?vue&type=script&lang=js&"
import style0 from "./setting-zapierConnections.vue?vue&type=style&index=0&id=530b02c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b02c0",
  null
  
)

export default component.exports